import { isArray } from "../../../../utils/zone.utils";
import { useCompareIsEqual } from "../../utils/useCompare";
import { isLayer } from "../validator/useLayerIdentity";
import useLayerChain from "../useLayerChain";
import useQueryCopySource, { useQueryLayerByCopySource } from "../store/useStoreCopySource"
import useQueryOriginalSourceByLayer, { storeOriginalSourceByLayer, swapLayerUsingOriginalSource } from "../store/useStoreOriginalSource";
import { deleteLayerUsingOriginalSource } from "../store/useStoreLayerUsingOriginalSource";
import useQueryParentLayer from "../store/useStoreLayerParent";
import useLogStack from "../../utils/useLogStack";
import { deletePathByLayer, storePathByLayer, swapPathByLayer } from "../store/useStorePathByLayer";


const updateWhenObject = (layer, target, key, value, propertyPath, chainId) => {
    /**
     * IMPORTANT
     * If the prop 'key' is a proxy, need query Proxy then re-update value, make sure not assign new object. Because it will break the reference
     */
    if (value && typeof value === 'object' && !isArray(value) && isLayer(target[key]) && !isLayer(value)) {
        useLogStack('updateWhenObject', layer, { propertyPath, key, value });
        const { queryLayerByPath } = useLayerChain(chainId)
        const clone = propertyPath.clone();
        value = Object.assign(target[key], value);
        clone.push(key);
        const old = layer;
        layer = queryLayerByPath(clone);
        if (layer) {
            storeOriginalSourceByLayer(layer, value)
            return Object.assign(layer, value);
        }
        return value;
    }
}

const updateWhenArray = (layer, target, key, value, propertyPath, chainId) => {
    if (!isArray(value)) return;
    let array = value;
    useLogStack('updateWhenArray', layer, { propertyPath, key, value });
    if (isLayer(value)) {
        array = useQueryOriginalSourceByLayer(value);
    }
    if (isLayer(target[key]) && Array.isArray(array)) {
        target[key] = value;
        return target[key]
    } else if (Array.isArray(array)) {
        return array;
    }
    return value
}

const updateWhenLayer = (layer, target, key, value, propertyPath, chainId) => {
    /**
     * IMPORTANT
     * If the prop 'key' is a proxy, need query Proxy then re-update value, make sure not assign new object. Because it will break the reference
     */

    if (!isLayer(value)) return;
    if (value && typeof value === 'object' && isLayer(target[key])) {
        useLogStack('updateWhenLayer', layer, { propertyPath, key, value, target });
        const { queryLayerByPath } = useLayerChain(chainId)
        const clone = propertyPath.clone();
        clone.push(key);
  
        // layer = layer[key];
        const originByValue = useQueryOriginalSourceByLayer(value);
        const old = layer;
        layer = queryLayerByPath(clone);

        if (layer) {
            const oldSource = useQueryOriginalSourceByLayer(layer);
            const newSource = useQueryOriginalSourceByLayer(value);

            swapLayerUsingOriginalSource(layer, newSource, key);
            swapPathByLayer(layer, propertyPath);

            const copySource = useQueryCopySource(layer)

            const s = Object.assign(layer, value);
            return s;
            // layer[key] = value;
            // return s;
        }
    }
}


const tryUpdateIfNotPrimitive = (layer, target, key, value, propertyPath, chainId) => {
    const copySource = useQueryCopySource(layer);
    let updatedValue = updateWhenArray(layer, target, key, value, propertyPath, chainId)
    if (!!updatedValue) {
        Reflect.set(copySource, key, value);
        return updatedValue
    }

    updatedValue = updateWhenObject(layer, target, key, value, propertyPath);
    if (!!updatedValue) {
        return updatedValue
    }
    updatedValue = updateWhenLayer(layer, target, key, value, propertyPath, chainId)
    if (!!updatedValue) {
        return updatedValue
    }

    if (value !== undefined) {
        Reflect.set(copySource, key, value);
    }
}

const useUpdateLayer = (propertyPath, layer, key, value, chainId) => {
    const copySource = useQueryCopySource(layer);
    const oldValue = copySource[key];
    if (useCompareIsEqual(value, oldValue, propertyPath, layer, key)) return true;
    tryUpdateIfNotPrimitive(layer, copySource, key, value, propertyPath, chainId)
    return true;
}

export default useUpdateLayer